"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeApi = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../../core/utils");
var _propTypes2 = require("../../../core/propTypes");
var _ModalFocusHelper = _interopRequireDefault(require("../../containers/ModalFocusHelper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var themeApi = exports.themeApi = ['html_withModal', 'modalsStack'];
var propTypes = {
  theme: _utils.theming.getThemePropTypesShape(themeApi).isRequired,
  modalNameToComponentMap: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes2.reactComponentShape, _propTypes["default"].func])).isRequired,
  visibleModalsNames: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired
};
var ModalsStack = /*#__PURE__*/function (_Component) {
  function ModalsStack() {
    _classCallCheck(this, ModalsStack);
    return _callSuper(this, ModalsStack, arguments);
  }
  _inherits(ModalsStack, _Component);
  return _createClass(ModalsStack, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.toggleVisible(this.props.visibleModalsNames);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.visibleModalsNames.length !== this.props.visibleModalsNames.length) {
        this.toggleVisible(this.props.visibleModalsNames);
      }
    }

    /* eslint-disable camelcase */
  }, {
    key: "toggleVisible",
    value: function toggleVisible(visibleModalsNames) {
      var html_withModal = this.props.theme.html_withModal;
      var htmlClassList = document.getElementsByTagName('html')[0].classList;
      if (visibleModalsNames.length > 0) {
        htmlClassList.add(html_withModal);
      } else {
        htmlClassList.remove(html_withModal);
      }
    }
    /* eslint-enable camelcase */
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        modalNameToComponentMap = _this$props.modalNameToComponentMap,
        visibleModalsNames = _this$props.visibleModalsNames,
        theme = _this$props.theme;
      var previousModalName = '';
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: theme.modalsStack
      }, visibleModalsNames.length > 0 && visibleModalsNames.map(function (modalName) {
        var modal = /*#__PURE__*/_react["default"].createElement(_ModalFocusHelper["default"], {
          key: modalName,
          previousModalName: previousModalName
        }, /*#__PURE__*/_react["default"].createElement(modalNameToComponentMap[modalName]));
        previousModalName = modalName;
        return modal;
      }));
    }
  }]);
}(_react.Component);
ModalsStack.propTypes = propTypes;
var _default = exports["default"] = ModalsStack;